import { getTrpcErrorCode, isUserFacingTrpcError } from '@algoacademy/backend/trpc/client-errors'
import {
  showErrorToastWithAlgoPhoneNumber,
  showTrpcMutationErrorToast
} from '@algoacademy/design-system/web/feedback/Toaster/ToasterError'
import { CAPTCHA_RETRY_MESSAGE } from '@algoacademy/shared/captcha'

/** Public intake needs a contact fallback that does not itself depend on CAPTCHA. */
export function showPublicFormError(error: unknown) {
  const code = getTrpcErrorCode(error)
  if (
    code &&
    code !== 'INTERNAL_SERVER_ERROR' &&
    isUserFacingTrpcError(error) &&
    error.message !== CAPTCHA_RETRY_MESSAGE
  ) {
    showTrpcMutationErrorToast(error)
    return
  }
  showErrorToastWithAlgoPhoneNumber()
}
